import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import { VBtn, VTextField, VInput } from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr';

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#006E33',
        secondary: '#C18A35',
        grey: '#646363',
        accent: '#82B1FF',
        error: '#FD3050',
        info: '#49a6f2',
        success: '#00D06C',
        warning: '#FF9800'
      }
    }
  },
  lang: {
    locales: { fr },
    current: 'fr'
  },
  icons: {
    values: {
      // chicken: {
      //   component: IconLotsPlans
      // },
      // aliment: {
      //   component: IconAliment
      // },
      // contrat: {
      //   component: IconContrat
      // }
    }
  }
});

VTextField.extendOptions.props.outlined.default = true;
VInput.extendOptions.props.dense.default = true;

VBtn.extendOptions.props.rounded.default = true;
VBtn.extendOptions.props.large = { default: true };
VBtn.extendOptions.props.color = { default: 'primary' };

if (vuetify.framework.breakpoint.xsOnly) {
  // VBtn.extendOptions.props.block.default = true;
}

export default vuetify;
